var mainSliderMobileEffectsDuration=500;
var mainSliderMobileInterval=5000;

function mainSliderMobileInit(){
    var datas = $("data > slide", ".slider-small");
    var area = $(".slide", ".slider-small");

    $(".slide-nav", area).html("");
    for (var i = 0; i < datas.length; i++) {
        var control = $('<i class="fa fa-circle-thin" pos="'+i+'"></i>');
        control.on("click", function(){
            mainSliderMoblieShow($(this).attr("pos"));
        });
        $(".slide-nav", area).append(control);
    }

    mainSliderMoblieShow(0);
    setTimeout(mainSliderMoblieAutoShow, mainSliderMobileInterval+mainSliderMobileEffectsDuration*2);
}

function mainSliderMoblieAutoShow(){
    if(!$(".slide", ".slider-small").is(":hover")){
        mainSliderMoblieShow();
    }

    setTimeout(mainSliderMoblieAutoShow, mainSliderMobileInterval+mainSliderMobileEffectsDuration*2);
}

function mainSliderMoblieShow(pos) {
    //console.warn(direction + ", "+ pos);

    var datas = $("data > slide", ".slider-small");
    if (datas.length == 0) return;
    var area = $(".slide", ".slider-small");

    if (isNullOrUndefined(pos)) {
        pos = (isNullOrUndefined(area.attr("slider-current")) ? 0 : (area.attr("slider-current") * 1)) + 1;
        if (pos < 0) pos = datas.length-1;
        else if (pos > datas.length - 1) pos = 0;
    }

    var data = datas[pos];
    data = $(data);

    $(".slide-nav > i", area).removeClass("sel");
    $($(".slide-nav > i", area)[pos]).addClass("sel");

    if (isNullOrUndefined(area.attr("slider-current"))) {
        mainSliderMobileFillBegin(area, data);
    }
    else {
        $(".text", area).addClass("animate-hide");
        setTimeout(function () {
            mainSliderMobileFillBegin(area, data);
        }, mainSliderEffectsDuration);
    }

    area.attr("slider-current", pos);
}

function mainSliderMobileFillBegin(area, data) {
    $(".date > .day", area).html(data.attr("date_d"));
    $(".date > .month", area).html(data.attr("date_m"));
    $(".date > .year", area).html(data.attr("date_y"));

    $("a.title > span", area).html(data.attr("title"));
    $("a.title", area).prop("href", data.attr("link"));

    setTimeout(function(){
        $(".text", area).removeClass("animate-hide");
    }, 100);
}